/**
 * DOMPurify: санитизация HTML на клиенте для защиты от XSS.
 * Контент из доверенного JSON (i18n) дополнительно очищается при рендере в браузере.
 */
import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li', 'span', 'h1', 'h2', 'h3']

export default defineNuxtPlugin(() => {
  return {
    provide: {
      sanitizeHtml(html: string | undefined | null): string {
        if (html == null || html === '') return ''
        return DOMPurify.sanitize(html, { ALLOWED_TAGS })
      },
    },
  }
})
